module.exports = __webpack_public_path__ + "img/stock6.3b595748.png";